import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

// Example of usage
// <sn-login-form (authLogin)="login_user($event)"></sn-login-form>

@Component({
  selector: 'sn-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.sass']
})
export class LoginFormComponent implements OnInit {
  @Output() authLogin = new EventEmitter<any>();

  loginForm: UntypedFormGroup;

  ngOnInit() {
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.email, Validators.required]),
      pass: new UntypedFormControl('', [Validators.required, Validators.minLength(2)])
    });
  }

  login_user() {
    if (this.loginForm.valid) {
      const { email, pass } = this.loginForm.value;

      this.authLogin.emit({ email, password: pass });
    }
  }

  isValueInvalid(control) {
    return !control || (control.touched && control.invalid);
  }
}
